import store from "../store";
import Web3 from "web3";

/*
 * metaMask
 */
const initMetaMask = () => {
    return new Promise((resolve, reject) => {
        if (window.ethereum) {
            const mateethereum = window.ethereum;
            window.globalWeb3 = new Web3(mateethereum);
            mateethereum.request({method: 'eth_requestAccounts'}).then((accounts) => {
                resolve(accounts);
            }).catch(() => {
                reject('User denied account access...');
            });
        } else {
            // reject('Please install MetaMask!');
            //
            // setTimeout(() => {
            //     window.open('https://chromewebstore.google.com/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?utm_source=ext_app_menu', '_blank');
            // }, 2000);
        }
    });
}

const connectMetaMask = async () => {
    let accounts = [];
    if (window.ethereum) {
        await initMetaMask();
        accounts = window.globalWeb3.eth.accounts;
    }
    if (!accounts || !accounts[0]) {
        accounts = await initMetaMask();
    }
    if (accounts.length === 0) {
        throw new Error('no accounts');
    }
    store.commit("setState", {
        accounts,
        connectType: 0,
    });
    localStorage.setItem('accounts', accounts[0]);
}

/*
 * OKX
 */
const initOKX = () => {
    return new Promise((resolve, reject) => {
        if (window.okxwallet) {
            const okxwallet = window.okxwallet;
            window.globalWeb3 = new Web3(okxwallet);
            okxwallet.request({method: 'eth_requestAccounts'}).then((accounts) => {
                resolve(accounts);
            }).catch(() => {
                reject('User denied account access...');
            });
        } else {
            // reject('OKX is installed!');
            //
            // setTimeout(() => {
            //     window.open('https://chromewebstore.google.com/detail/%E6%AC%A7%E6%98%93-web3-%E9%92%B1%E5%8C%85/mcohilncbfahbmgdjkbpemcciiolgcge', '_blank');
            // }, 2000);
        }
    });
}

const connectOKX = async () => {
    let accounts = [];
    if (window.okxwallet) {
        await initOKX();
        accounts = window.globalWeb3.eth.accounts;
    }
    if (!accounts || !accounts[0]) {
        accounts = await initOKX();
    }
    if (accounts.length === 0) {
        throw new Error('no accounts');
    }
    store.commit("setState", {
        accounts,
        connectType: 0,
    });
    localStorage.setItem('accounts', accounts[0]);
}

/*
 * TokenPocket
 */
const initTP = () => {
    return new Promise((resolve, reject) => {
        if (window.tokenpocket.ethereum) {
            const tpwallet = window.tokenpocket.ethereum;
            window.globalWeb3 = new Web3(tpwallet);
            tpwallet.request({method: 'eth_requestAccounts'}).then((accounts) => {
                resolve(accounts);
            }).catch(() => {
                reject('User denied account access...');
            });
        } else {
            // reject('TokenPocket is installed!');
            //
            // setTimeout(() => {
            //     window.open('https://chromewebstore.google.com/search/TokenPocket%20-%20Web3%20%26%20Crypto%20%E9%92%B1%E5%8C%85?hl=zh-CN&utm_source=ext_sidebar', '_blank');
            // }, 2000);
        }
    });
}

const connectTP = async () => {
    let accounts = [];
    if (window.tokenpocket.ethereum) {
        await initTP();
        accounts = window.globalWeb3.eth.accounts;
    }
    if (!accounts || !accounts[0]) {
        accounts = await initTP();
    }
    if (accounts.length === 0) {
        throw new Error('no accounts');
    }
    store.commit("setState", {
        accounts,
        connectType: 0,
    });
    localStorage.setItem('accounts', accounts[0]);
}

export {
    connectMetaMask,
    connectOKX,
    connectTP
}
